module.exports = __webpack_public_path__ + "img/hr.0c71df06.svg";